import React from 'react'

import { createTheme, ThemeProvider } from '@mui/material/styles'
import defaultTheme from './theme.json'

export function ConnectedThemeProvider(props: any): JSX.Element {
  const muiTheme = createTheme(defaultTheme)
  return <ThemeProvider {...props} theme={muiTheme} />
}
